import getLangLocale from 'I18n/utils/getLangLocale';
const GIVEN_NAME = 'GIVEN';
const FAMILY_NAME = 'FAMILY';
const FAMILY_GIVEN = [FAMILY_NAME, GIVEN_NAME];
const GIVEN_FAMILY = [GIVEN_NAME, FAMILY_NAME];
const FAMILY_GIVEN_LOCALES = new Set(['hu', 'hu-hu', 'ja', 'ja-jp', 'ko', 'ko-kr', 'vi', 'vi-vn', 'zh', 'zh-cn', 'zh-hk', 'zh-tw']);
export default ((locale = getLangLocale()) => {
  if (FAMILY_GIVEN_LOCALES.has(locale)) {
    return FAMILY_GIVEN;
  }
  return GIVEN_FAMILY;
});